var swiper = new Swiper(".video-block-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1200: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    990: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    0: {
      slidesPerView: 1.5,
      spaceBetween: 20
    },
  }
});

function loadVideoPreview(btn) {
  if (!btn || btn.dataset.previewLoaded === "true") return;

  const template = btn.querySelector(".video-preview-template");
  if (!template) return;

  const poster = btn.querySelector("img.video-preview");
  const playButton = btn.querySelector(".video-play-btn");

  if (template.content) {
    btn.insertBefore(template.content.cloneNode(true), playButton || null);
  } else {
    btn.insertAdjacentHTML("afterbegin", template.innerHTML);
  }

  if (poster) poster.remove();
  btn.dataset.previewLoaded = "true";

  const video = btn.querySelector("video.video-preview");
  if (video) {
    video.muted = true;
    video.playsInline = true;
    video.play().catch(() => {});
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".video-open-btn");

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        loadVideoPreview(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: "400px 0px" });

    buttons.forEach(button => observer.observe(button));
  } else {
    buttons.forEach(loadVideoPreview);
  }
});


document.addEventListener("click", function (e) {

  const btn = e.target.closest(".video-open-btn");
  if (!btn) return;

  const modal = document.getElementById("videoModal");
  const container = document.getElementById("videoContainer");

  const videoId = btn.getAttribute("data-video-id");
  const videoTemplate = document.getElementById(videoId);

  if (videoTemplate) {
    container.innerHTML = "";

    if (videoTemplate.content) {
      container.appendChild(videoTemplate.content.cloneNode(true));
    } else {
      container.innerHTML = videoTemplate.innerHTML;
    }

    modal.classList.add("active");

    const video = container.querySelector("video");
    if (video) {
      video.currentTime = 0;
      video.controls = true;
      video.play();
    }
  }
});

// CLOSE
document.addEventListener("click", function (e) {
  if (
    e.target.closest(".video-close") ||
    e.target.closest(".video-modal-overlay")
  ) {
    const modal = document.getElementById("videoModal");
    const container = document.getElementById("videoContainer");

    modal.classList.remove("active");
    container.innerHTML = "";
  }
});
